Services =  {

	init : ->
		console.log 'Services init'

		@switchServices()

	switchServices : ->
		$('.block-services .cta_switch-services').on "click", (ev) ->
			
			# Retrieve old and new contents
			oldContent = $('.services-content.active')
			newContent = $('.services-content').not('.active')

			# Retrieve old and new CTAs
			oldCTA = $('.cta_switch-services.active')
			newCTA = $('.cta_switch-services').not('.active')

			# Retrieve old and new titles
			oldTitle = $('.block-services .section-title.active')
			newTitle = $('.block-services .section-title').not('.active')

			tlSwitchServices = new TimelineLite
			tlSwitchServices.addLabel('start')
				# Hide old content
				.staggerFromTo(oldContent.find('.service'), 0.4, {y:0, autoAlpha:1}, {y:-20, autoAlpha:0, ease:Back.easeInOut}, 0.05)
				
				# Hide old title
				.fromTo(oldTitle.find('span'), 0.4, {autoAlpha:1, x:0}, {autoAlpha:0, x:30, ease:Quint.easeInOut}, 'start')
				# Switch title classes
				.add ->
					oldTitle.removeClass('active');
					newTitle.addClass('active');

				# Hide old CTA label
				.fromTo(oldCTA, 0.4, {rotationX:0, autoAlpha:1, y:0}, {rotationX:'90deg', autoAlpha:0, y:-10, ease:Back.easeInOut}, 'start')
				# Switch cta classes
				.add ->
					oldCTA.removeClass('active')
					newCTA.addClass('active')
				
				# Switch content classes
				.add ->
					oldContent.removeClass('active')
					newContent.addClass('active')
				.addLabel('show')
				# Show new content
				.staggerFromTo(newContent.find('.service'), 0.4, {y:20, autoAlpha:0}, {y:0, autoAlpha:1, ease:Back.easeInOut}, 0.05, "show")
				# Show new title
				.fromTo(newTitle.find('span'), 0.4, {autoAlpha:0, x:-30}, {autoAlpha:1, x:0, ease:Quint.easeInOut}, 'show')
				# Show new CTA label
				.fromTo(newCTA, 0.4, {rotationX:'-90deg', autoAlpha:0, y:10}, {rotationX:0, autoAlpha:1, y:0, ease:Back.easeInOut})

			

	destroy : ->
		console.log "Services destroy"
		
}